export default {
  terms: {
    id: 'insurances_options_terms_terms',
    defaultMessage: 'Terms and Conditions',
  },
  ipid: {
    id: 'insurances_options_terms_ipid',
    defaultMessage: 'Insurance Product Information Document',
  },
  recap: {
    id: 'insurances_options_terms_recap',
    defaultMessage: 'Backmarket Recap',
  },
  and: {
    id: 'insurances_options_terms_and',
    defaultMessage: 'and',
  },
  insuranceUpfront: {
    id: 'terms_insurance_upfront',
    defaultMessage:
      'By purchasing this service plan, I have read and accepted the {documents, html}.',
  },
  insuranceMonthly: {
    id: 'terms_insurance_monthly',
    defaultMessage:
      'I have read and accepted the {documents, html} I understand that my Protection Plan will renew automatically every month, and I agree that my payment method will be charged every month until I cancel.',
  },
  insuranceAnnually: {
    id: 'terms_insurance_annually',
    defaultMessage:
      'I have read and accepted the {documents, html} I understand that my Protection Plan will renew automatically every year, and I agree that my payment method will be charged every year until I cancel.',
  },
  insuranceBiennial: {
    id: 'terms_insurance_biennial',
    defaultMessage:
      'I have read and accepted the {documents, html}. I understand that my Protection Plan will renew automatically every two years, and I agree that my payment method will be charged every two years until I cancel.',
  },
  protectionServiceUpfront: {
    id: 'terms_protection_service_upfront',
    defaultMessage:
      'By purchasing this service plan, I have read and accepted the {documents, html}.',
  },
  protectionServiceMonthly: {
    id: 'terms_protection_service_monthly',
    defaultMessage:
      'I have read and accepted the {documents, html} I understand that my Protection Plan will renew automatically every month, and I agree that my payment method will be charged every month until I cancel.',
  },
  protectionServiceAnnually: {
    id: 'terms_protection_service_annually',
    defaultMessage:
      "I confirm I'm 18 or older. I'm signing up for minimum 1-year of Repair & Replace. After that, my plan renews automatically every year. I can cancel for a refund within 30 days of enrollment or within 30 days of each renewal. See the {documents, html}.",
  },
  protectionServiceBiennial: {
    id: 'terms_protection_service_biennial',
    defaultMessage:
      'I have read and accepted the {documents, html}. I understand that my Protection Plan will renew automatically every two years, and I agree that my payment method will be charged every two years until I cancel.',
  },
  faqLabel: {
    id: 'terms_cancellation_faq_label',
    defaultMessage: 'I can easily cancel anytime {faqlink, html}.',
  },
  faqLinkLabel: {
    id: 'terms_cancellation_faq_link',
    defaultMessage: 'through my account',
  },
  faqLinkValue: {
    id: 'terms_cancellation_faq_link_value',
    defaultMessage:
      'https://help.backmarket.com/hc/en-us/articles/4404019304594-Can-I-cancel-my-Protection-Plan',
  },
}
